import { BUSINESS_CODE } from '@cockpitai/constants/permissions'
import { useGetAffiliateDetailsQuery } from '@cockpitai/integration/panels/hooks/useGetAffiliateDetailsQuery'
import { useFilterPanels } from '@cockpitai/pages/dashboard/Panels/useFilterPanels'
import { useMemo } from 'react'

type UseAuthorizeProps = {
  businessCode: BUSINESS_CODE[] | []
}

export function useAuthorize({ businessCode }: UseAuthorizeProps) {
  const filterPanels = useFilterPanels()

  const { data: affiliate } = useGetAffiliateDetailsQuery(filterPanels)

  return useMemo(() => {
    const affiliateCode = affiliate?.businessCode

    return (
      affiliate?.id &&
      (affiliateCode === null ||
        businessCode.length === 0 ||
        (businessCode as BUSINESS_CODE[]).includes(
          affiliateCode as BUSINESS_CODE,
        ))
    )
  }, [affiliate, businessCode])
}
